import { initializeApp } from 'firebase/app';
import { initializeAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyAgAPaDVwFhVG3KhxPNolgTl_20xXK-X1I",
  authDomain: "inxits-customer-app.firebaseapp.com",
  projectId: "inxits-customer-app",
  storageBucket: "inxits-customer-app.firebasestorage.app",
  messagingSenderId: "98371695796",
  appId: "1:98371695796:web:2b851442c75f838d0693e1",
  measurementId: "G-WF4W2GZQMS",
};

const app = initializeApp(firebaseConfig);

// initializeAnalytics is SYNCHRONOUS — no race condition with early events
// debug_mode: true sends events to Firebase DebugView instantly in dev
let analytics = null;
try {
  analytics = initializeAnalytics(app, {
    config: import.meta.env.DEV ? { debug_mode: true } : {},
  });
} catch (e) {
  console.warn('[Firebase] Analytics init failed:', e.message);
}

export { analytics };
export default app;
